import React from 'react';
import { Card } from 'semantic-ui-react';
import { isLoaded } from 'react-redux-firebase';
import SectionCard from '../SectionCard/component';

import './index.css';

const createSectionCards = (sections, sectionIds) => (
  sections.map((section, i) => (
    <SectionCard
      title={section.title}
      date={section.date}
      description={section.description}
      key={i}
      sectionId={sectionIds[i]}
    />))
);

const MenuComponent = ({ sections, firebase }) => {
  if (!isLoaded(sections)) { return null; }

  const sectionNames = Object.values(sections).sort((a, b) => a.order - b.order);
  const sectionIds = Object.keys(sections);
  return (
    <div>
      <Card.Group className="section-selector" textAlign="center">
        {createSectionCards(sectionNames, sectionIds)}
      </Card.Group>
    </div>
  );
};

export default MenuComponent;



// WEBPACK FOOTER //
// ./src/modules/SectionSelector/component.js